import React from 'react';
import { PersonTimelineRecordTypeFilter } from 'domain/shared/timeline';
import EmployeeTimelineRecordTypeDropdown from '../input/EmployeeTimelineRecordTypeDropdown';
import { Box, Switch, Typography } from '@mui/material';
import { useFilterContext } from 'framework/list';

const CREATED_BY_DAVINCI_FILTER_SOURCE = 'isCreatedByDavinci';
const NOT_EQUAL_OR_NULL_CONDITION = 'ne_or_null';

interface EmployeeTimelineRecordTypeFilterProps {
  cleanableFilters?: string[];
  source: string;
  [key: string]: any;
}

const EmployeeTimelineRecordTypeFilter = ({
  cleanableFilters = [],
  source,
  ...props
}: EmployeeTimelineRecordTypeFilterProps) => {
  const { filters, quickFilter } = useFilterContext();
  const showAllActivities = filters?.[CREATED_BY_DAVINCI_FILTER_SOURCE]?.[NOT_EQUAL_OR_NULL_CONDITION] !== true;

  const handleShowAllActivitiesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextFilters = { ...filters };

    if (event.target.checked) {
      delete nextFilters[CREATED_BY_DAVINCI_FILTER_SOURCE];
    } else {
      nextFilters[CREATED_BY_DAVINCI_FILTER_SOURCE] = {
        [NOT_EQUAL_OR_NULL_CONDITION]: true,
      };
    }

    quickFilter(nextFilters);
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Typography color="textSecondary">Show all activities</Typography>
        <Switch
          checked={showAllActivities}
          slotProps={{ input: { 'aria-label': 'Show all activities' } }}
          onChange={handleShowAllActivitiesChange}
          size="small"
        />
      </Box>
      <PersonTimelineRecordTypeFilter
        {...props}
        cleanableFilters={cleanableFilters}
        source={source}
        dropdownComponent={EmployeeTimelineRecordTypeDropdown}
      />
    </>
  );
};

export default EmployeeTimelineRecordTypeFilter;
